/**
 * EdgeDeleteConfirmation Component
 *
 * Reusable confirmation dialog for edge deletion.
 * Used by both TransitionEditor and keyboard delete handlers.
 */

import React from 'react';
import { Typography } from '@mui/material';
import {
  BaseDialog,
  DialogHeader,
  DialogContent,
  DialogFooter,
} from '@modules/ui-components';

export interface EdgeDeleteConfirmationProps {
  /** Whether dialog is open */
  open: boolean;

  /** Callback when dialog is closed (Cancel) */
  onClose: () => void;

  /** Callback when deletion is confirmed */
  onConfirm: () => void;

  /** Optional message to display */
  message?: string;
}

export const EdgeDeleteConfirmation: React.FC<EdgeDeleteConfirmationProps> = ({
  open,
  onClose,
  onConfirm,
  message = 'Are you sure you want to delete this connection?',
}) => {
  return (
    <BaseDialog
      open={open}
      onClose={onClose}
      mode="modal"
      maxWidth="xs"
    >
      <DialogHeader
        title="Confirm Deletion"
        onClose={onClose}
      />

      <DialogContent>
        <Typography>{message}</Typography>
      </DialogContent>

      <DialogFooter
        primaryAction={{
          label: 'Delete',
          onClick: onConfirm,
          variant: 'contained',
          color: 'error',
        }}
      />
    </BaseDialog>
  );
};
